<div class="layout__top-wrapper" *ngIf="layoutTop?.length > 0">
    <ng-content select="layout-top"></ng-content>
</div>

<div class="layout__wrapper">
    <ng-content></ng-content>
</div>
